<template>
    <b-container 
        class="content" 
        fluid 
    >
        <b-row>
            <b-col style="text-align: left; font-weight: bold; font-size: 20px">{{ $t('update location') }}</b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col style="text-align: left; font-weight: bold">
                <span>{{ $t('site name') }}</span>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="6">
                <b-form-input
                    v-model="name"
                    @focus.native="errors.name = false"
                    :class="{'is-invalid': errors.name }"
                />
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>{{ $t('dataTypes') }}</span>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="6" class="test">
                <multiselect
                    :class="{'is-invalid': errors.dataTypes}"
                    @focus.native="errors.dataTypes = false"
                    v-model="dataTypes"
                    :multiple="true"
                    :options="allDataTypes"
                    :close-on-select="true"
                    :showLabels="false"
                    :placeholder="$t('choose')"
                    label="name"
                    track-by="id"
                />
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>{{ $t('dataTypeForHeating') }}</span>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="6">
                <b-form-select
                    v-model="heatingDataTypeModel"
                    @focus.native="errors.heatingDataTypeModel = false"
                    :class="{'is-invalid': errors.heatingDataTypeModel }"
                    type="number"
                >
                    <option :value="-1" :disabled="true">{{$t('choose')}}</option>
                    <option
                        v-for="heatingType in heatingDataTypes"
                        v-bind:ref="'heating'"
                        :value="heatingType.id"
                        :key="heatingType.id"
                    >{{ $t(heatingType.name) }}</option>
                </b-form-select>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>{{ $t('cityTitle') }}</span>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="6">
                <b-form-select
                    v-model="cityCode"
                    @focus.native="errors.cityCode = false"
                    :class="{'is-invalid': errors.cityCode }"
                >
                    <option :value="null" :disabled="true">{{ $t('choose') }}</option>
                    <option v-for="city in $store.state.cities" :value="city.code">{{ city.name }}</option>
                </b-form-select>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>{{ $t('regionTitle') }}</span>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="6">
                <b-form-select
                    v-model="region"
                    @focus.native="errors.region = false"
                    :class="{'is-invalid': errors.region }"
                >
                    <option :value="null" :disabled="true">{{ $t('choose') }}</option>
                    <option v-for="group in siteGroups" :value="group.id">{{ group.display_name }}</option>
                </b-form-select>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>{{ $t('siteCode') }}</span>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="6">
                <b-form-input
                    v-model="code"
                    @focus.native="errors.code = false"
                    :class="{'is-invalid': errors.code }"
                />
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>{{ $t('areaTitle') }}</span>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="6">
                <b-form-input
                    v-model="area"
                    @focus.native="errors.area = false"
                    :class="{'is-invalid': errors.area }"
                    type="number"
                />
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>{{ $t(this.getGroupName('agent')) }}</span>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="6">
                <b-form-select
                    v-model="siteAgentModel"
                    @focus.native="errors.siteAgentModel = false"
                    :class="{'is-invalid': errors.siteAgentModel }"
                    type="number"
                >
                    <option :value="-1" :disabled="true">{{$t("none")}}</option>
                    <option
                        v-for="siteAgent in agentUsers"
                        :value="siteAgent.id"
                        :key="siteAgent.id"
                    >{{ siteAgent.first_name + " " + siteAgent.last_name }}</option>
                </b-form-select>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <template v-if="this.isbId(this.$store.state.user.customerId)"><span>{{ $t('technician') }}</span></template>
                <template v-else><span>{{ $t('sub-agent') }}</span></template>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="6" v-if="userList.length == 1">
                <b-form-select
                    v-model="siteSubAgentModel"
                    @focus.native="errors.siteSubAgentModel = false"
                    :class="{'is-invalid': errors.siteSubAgentModel }"
                    type="number"
                >
                    <option :value="-1">{{$t("none")}}</option>
                </b-form-select>
            </b-col>
            <b-col cols="6" v-else>
                <b-form-select
                    v-model="siteSubAgentModel"
                    @focus.native="errors.siteSubAgentModel = false"
                    :class="{'is-invalid': errors.siteSubAgentModel }"
                    type="number"
                >
                    <option :value="-1">{{$t("none")}}</option>
                    <option
                        v-for="subSiteAgent in subAgentUsers"
                        :value="subSiteAgent.id"
                        :key="subSiteAgent.id"
                    >{{ subSiteAgent.first_name + " " + subSiteAgent.last_name}}</option>
                </b-form-select>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>{{ $t(this.getGroupName('supervisor')) }}</span>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="6">
                <b-form-select
                    v-model="siteSupervisorModel"
                    @focus.native="errors.siteSupervisorModel = false"
                    :class="{'is-invalid': errors.siteSupervisorModel }"
                    type="number"
                >
                    <option :value="-1" :disabled="true">{{$t("none")}}</option>
                    <option
                        v-for="supervisor in supervisorUsers"
                        :value="supervisor.id"
                        :key="supervisor.id"
                    >{{ supervisor.first_name + " " + supervisor.last_name}}</option>
                </b-form-select>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>{{ $t('manager') }}</span>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="6">
                <b-form-input
                    v-model="directors"
                    @focus.native="errors.directors = false"
                    :class="{'is-invalid': errors.directors }"
                    :disabled="true"
                />
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>{{ $t('includeInEmissionsCalculations') }}</span>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="1">
                <b-form-checkbox
                    id="emission_checkbox"
                    name="emission_checkbox"
                    v-model="emissionModel"
                    value="1"
                    unchecked-value="0"
                ></b-form-checkbox>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>{{ $t('is open') }}</span>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="1">
                <b-form-checkbox
                    id="isOpen_checkbox"
                    name="isOpen_checkbox"
                    v-model="isOpenModel"
                    value="1"
                    unchecked-value="0"
                ></b-form-checkbox>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>{{ $t('number of people') }}</span>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="6">
                <b-form-input
                    v-model="staffCount"
                    @focus.native="errors.staffCount = false"
                    :class="{'is-invalid': errors.staffCount }"
                    type="number"
                />
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left; font-weight: bold">
                <span>{{ $t('coordinates') }}</span>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="3">
                <b-form-input v-model="lat" placeholder="lat" type="number" />
            </b-col>
            <b-col cols="3">
                <b-form-input v-model="lng" placeholder="lng" type="number" />
            </b-col>
        </b-row>
        <b-row class="mt-4">
            <b-col cols="6">
                <b-row align-h="end">
                    <b-col cols="5" sm="5" md="5" lg="4">
                        <button
                            class="btn btn-lg btn-primary btn-block"
                            @click="update()"
                        >{{ $t("update") }}</button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import _ from 'lodash';
import Multiselect from 'vue-multiselect';

export default {
    name: 'SiteDetail',
    components: {
        Multiselect
    },
    data() {
        return {
            name: null,
            code: null,
            area: null,
            staffCount: null,
            lat: null,
            lng: null,
            cityCode: null,
            region: null,
            siteStaff: null,
            supervisorList: null,
            staff: null,
            selectedAgent: null,
            siteAgent: null,
            siteAgentModel: null,
            siteSubAgentModel: null,
            siteSupervisorModel: null,
            heatingDataTypeModel: null,
            heatingDataTypes: null,
            emissionModel: null,
            isOpenModel: null,
            dataTypes: [],
            allDataTypes: [],
            userList: [],
            agentUsers: [],
            subAgentUsers: [],
            supervisorUsers: [],
            directors: '',
            errors: {
                name: false,
                code: false,
                area: false,
                staffCount: false,
                lat: false,
                lng: false,
                cityCode: false,
                region: false,
                siteAgentModel: false,
                siteSubAgentModel: false,
                siteSupervisorModel: false,
                directors: false,
                heatingDataTypeModel: false,
                dataTypes: false
            }
        };
    },
    methods: {
        validate() {
            // @todo: make this condition easier to read.
            if (
                !this.dataTypes.length ||
                (this.siteAgentModel != -1 && this.siteSubAgentModel == this.siteAgentModel)
            ) {
                return false;
            }
            for (let key in this.errors) {
                if (key !== 'lng' && key !== 'lat' && key !== 'directors') {
                    this.errors[key] = !this[key];
                }
            }
            // checks true value count of erros object
            return !Object.values(this.errors).filter(value => {
                return value;
            }).length;
        },
        getSiteName(agentSiteId) {
            let agentSite = _.find(this.sites, {id: agentSiteId});
            return agentSite.originalName;
        },
        update() {
            if (this.validate()) {
                let site = {
                    name: this.name,
                    code: this.code,
                    area: this.area,
                    staffCount: this.staffCount,
                    lon: this.lng || null,
                    lat: this.lat || null,
                    city: this.cityCode,
                    site_group_id: this.region,
                    site_agent: this.siteAgent,
                    dataTypes: this.dataTypes.map(dataType => dataType.id),
                    agentId: this.siteAgentModel,
                    subAgentId: this.siteSubAgentModel,
                    supervisorId: this.siteSupervisorModel,
                    calculateEmission: this.emissionModel,
                    isOpen: this.isOpenModel,
                    heatingDataType: this.heatingDataTypeModel
                };
                site.agentId = site.agentId == -1 ? null : site.agentId;
                site.subAgentId = site.subAgentId == -1 ? null : site.subAgentId;
                site.supervisorId = site.supervisorId == -1 ? null : site.supervisorId;

                this.$Progress.start();
                // TODO: area and staffcount do not belong to site table, therefore these data types request should be sent to site_property table.
                return this.axios
                    .put(`/sites/${this.route.params.site_id}`, site)
                    .then(() => {
                        this.sites = this.$store.state.sites;
                        this.sendMail(site);
                        this.$Progress.finish();
                    })
                    .catch(() => {
                        this.$Progress.fail();
                    });
            } else {
                // @todo: make this condition easier to read.
                this.siteSubAgentModel &&
                this.siteAgentModel != -1 &&
                this.siteSubAgentModel == this.siteAgentModel
                    ? this.$toasted.error(this.$t('duplicateAgents'))
                    : !this.dataTypes.length
                        ? this.$toasted.error(this.$t('missingDataType'))
                        : this.$toasted.error(this.$t('missingError'));
            }
        },
        sendMail(site) {
            // If there is a selected agent and that agent is not the same as current site agent send mail to director and supervisor.
            if (this.siteAgentModel != -1 && site.agentId != this.siteAgentModel) {
                // Send mails to agent, director and supervisor.
                this.axios
                    .post(`/siteMail/agent/${this.route.params.site_id}`)
                    .then(() => {
                        this.$toasted.show(this.$t('updated'));
                        setTimeout(() => this.$router.go(), 500);
                    })
                    .catch(() => {
                        this.$Progress.fail();
                    });
            } else {
                this.$toasted.show(this.$t('updated'));
                setTimeout(() => this.$router.go(), 500);
            }
        },
        getHeatingList() {
            return this.axios.get('/data-type/heating').then(({data}) => {
                this.heatingDataTypes = data;
                return data;
            });
        },
        getUserList() {
            return this.axios.get(`/userList/${this.route.params.site_id}`).then(({data}) => {
                this.userList = data.userList;
                this.agentUsers = this.userList.agents;
                this.subAgentUsers = this.isbId(this.$store.state.user.customerId) ? this.userList.subAgents : this.userList.agents;
                this.supervisorUsers = this.userList.supervisors;
                //this.agentUsers = _.filter(this.userList, function(o){ return o.groupId == 1 || o.groupId == 6});
                //this.supervisorUsers = _.filter(this.userList, function(o){ return o.groupId == 3});
                this.getAllSiteDetails();
                return data;
            });
        },
        getAllSiteDetails() {
            let foundSite = _.find(this.sites, {id: Number(this.route.params.site_id)});
            if (!_.isNil(foundSite)) {
                this.name = foundSite.originalName;
                this.cityCode = foundSite.cityCode;
                this.region = foundSite.siteGroupId;
                let currentAgentId = _.nth(foundSite.agentIds, 0);
                let currentSubAgentId = _.nth(foundSite.subAgentIds, 0);
                let currentSupervisorId = _.nth(foundSite.supervisorIds, 0);
                this.directors = _.get(_.get(foundSite, 'directors'),'0');
                this.code = foundSite.code;
                this.area = _.last(
                    _.reduce(
                        foundSite.yearlyProperties,
                        function(results, properties) {
                            var notNullArea = properties.area;
                            if (notNullArea) {
                                results.push(properties.area);
                            }
                            return results;
                        },
                        []
                    )
                );
                this.staffCount = _.last(
                    _.reduce(
                        foundSite.yearlyProperties,
                        function(results, properties) {
                            var notNullArea = properties.staffCount;
                            if (notNullArea) {
                                results.push(properties.staffCount);
                            }
                            return results;
                        },
                        []
                    )
                );
                this.siteAgent = foundSite.agents;
                /*this.siteStaff = _.filter(this.userList, function(o){
                    return o.site_id === foundSite.id;
                });
                
                this.staff = _.filter(this.userList, function(o){
                    return o.site_id !== foundSite.id;
                });
                */
                this.selectedAgent = _.find(this.agentUsers, function(o) {
                    return o.id == currentAgentId;
                });
                this.siteAgentModel = this.selectedAgent ? this.selectedAgent.id : '-1';
                var selectedSubAgent = _.find(this.agentUsers, function(o) {
                    return o.id == currentSubAgentId;
                });
                this.siteSubAgentModel = selectedSubAgent ? selectedSubAgent.id : '-1';
                /*
                let allSitesHaveSupervisor = _.filter(this.sites, function(o){
                    return o.supervisors !== null;
                });
                this.supervisorList = _.uniqBy(allSitesHaveSupervisor, 'supervisors');
                this.siteSupervisorModel = (_.find(allSitesHaveSupervisor, {id: Number(this.route.params.site_id)})) ? (_.find(allSitesHaveSupervisor, {id: Number(this.route.params.site_id)})).supervisorIds : -1;
                */
                var selectedSupervisor = _.find(this.supervisorUsers, function(o) {
                    return o.id == currentSupervisorId;
                });
                this.siteSupervisorModel = selectedSupervisor ? selectedSupervisor.id : '-1';

                this.emissionModel = foundSite.calculateEmission;
                this.isOpenModel = foundSite.isOpen;
                this.lat = foundSite.lat;
                this.lng = foundSite.lng;
                this.allDataTypes = this.$store.state.dataTypes;
                this.allDataTypes.forEach(dataType => {
                    dataType.name = this.$t(dataType.name);
                });
                this.dataTypes = _.filter(foundSite.dataTypes.map(dataType => {
                    return _.find(this.allDataTypes, {id: dataType});
                }), dataType => { return dataType !== undefined; });
                this.heatingDataTypeModel = foundSite.heatingDataType;
            }
        },
        fetchAllData() {
            this.$Progress.start();
            return Promise.all([this.getHeatingList(), this.getUserList()]).then(() => {
                this.$Progress.finish();
            });
        }
    },

    created() {
        this.fetchAllData();
    }
};
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
.multiselect__tags {
    padding: 12px 30px 0 8px;
    background: white;
    border: 1px solid #ced4da;
    input::placeholder {
        color: #696969;
    }
    .multiselect__single {
        font-size: 1em;
        color: black;
        background: white;
    }
    .multiselect__input {
        font-size: 1em;
        color: black;
        background: white;
    }
    .multiselect__tag {
        position: relative;
        display: inline-block;
        padding: 4px 26px 4px 10px;
        border-radius: 5px;
        margin-right: 10px;
        color: #fff;
        line-height: 1;
        background: #868e96;
        margin-bottom: 5px;
        white-space: nowrap;
        overflow: hidden;
        max-width: 100%;
        text-overflow: ellipsis;
        .multiselect__tag-icon:after {
            content: '\D7';
            color: #3f424a;
            font-size: 14px;
        }
    }
}
.multiselect__option--highlight {
    background: #868e96;
    outline: none;
    color: white;
}
</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "dataTypes": "Veri Tipleri",
            "dataTypeForHeating": "Yakıt için veri tipi",
            "siteCode": "Kod",
            "update location": "Lokasyon Güncelleme",
            "site name": "Lokasyon adı",
            "is open": "Açık mı?",
            "includeInEmissionsCalculations": "Emisyon hesaplarına dahil et",
            "coordinates": "Koordinatlar"
        },
        "en": {
            "dataTypes": "Data Types",
            "dataTypeForHeating": "Data Type for Heating",
            "siteCode": "Code",
            "update location": "Update Location",
            "site name": "Site Name",
            "is open": "Is Open?",
            "includeInEmissionsCalculations": "Include in Emissions Calculations",
            "coordinates": "Coordinates"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Setting/SiteEdit.vue